module.exports = __webpack_public_path__ + "img/miryoku2.55624540.jpg";